

export const createPhonePrefixAdapter = (key, name, value) => {
    return {
        key : key,
        text : `${name} (${value})`,
        flag : key.toLowerCase(),
        value : value,
    }
}